<div [style]="{ height: getHeight(), width: getWidth() }"></div>
